import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { DomainsForTableDTO } from 'features/inventory/domain/components/DomainsTable/types/api'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const DOMAIN_FOR_TABLE_FRAGMENT: TypedDocumentNode<DomainsForTableDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment DomainFragmentForTable on Domain {
    alerts {
      ...AlertFragment
    }
    domainUnfilledRecovery {
      baseAdUnitPath
    }
    id
    name
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
